import type { UniversalModifierValue } from "schemas/generated/fileModifiers";

import React from "react";

import AppearanceModifier from "./base/AppearanceModifier";
import BackgroundModifierComponent from "./base/BackgroundModifier";
import BorderModifier from "./base/BorderModifier";
import ContentModifierComponent from "./base/ContentModifier";
import PaddingModifierComponent from "./base/PaddingModifier";
import ShadowModifierComponent from "./base/ShadowModifier";
import StyleModifier from "./base/StyleModifier";
import TextColorModifierComponent from "./base/TextColorModifier";
import ModifierLayout from "./ModifierLayout";
import { useDefaultSelectedElementDesignation } from "./store/ModifiersStoreContext";

interface ButtonModifierBlockProps {
  onModifiersValueChange: (
    modifiers: UniversalModifierValue[],
    stableElementId: string,
  ) => void;
}

const ButtonModifierBlock: React.FC<ButtonModifierBlockProps> = ({
  onModifiersValueChange,
}) => {
  const defaultDesignation = useDefaultSelectedElementDesignation();

  if (!defaultDesignation) {
    return null;
  }

  const sections = [
    {
      rows: [
        {
          title: "Content",
          component: (
            <ContentModifierComponent
              onChange={(modifiers) => {
                onModifiersValueChange(
                  modifiers,
                  defaultDesignation.element.stableElementId,
                );
              }}
            />
          ),
        },
        {
          title: "Text Style",
          component: (
            <StyleModifier
              onChange={(modifiers) => {
                onModifiersValueChange(
                  modifiers,
                  defaultDesignation.element.stableElementId,
                );
              }}
            />
          ),
        },
        {
          title: "Text Color",
          component: (
            <TextColorModifierComponent
              onChange={(modifiers) => {
                onModifiersValueChange(
                  modifiers,
                  defaultDesignation.element.stableElementId,
                );
              }}
            />
          ),
        },
      ],
    },
    {
      rows: [
        {
          title: "Background",
          component: (
            <BackgroundModifierComponent
              onChange={(modifiers) => {
                onModifiersValueChange(
                  modifiers,
                  defaultDesignation.element.stableElementId,
                );
              }}
            />
          ),
        },
        {
          title: "Border",
          component: (
            <BorderModifier
              onChange={(modifiers) => {
                onModifiersValueChange(
                  modifiers,
                  defaultDesignation.element.stableElementId,
                );
              }}
            />
          ),
        },
      ],
    },
    {
      rows: [
        {
          title: "Padding",
          component: (
            <PaddingModifierComponent
              onChange={(modifiers) => {
                onModifiersValueChange(
                  modifiers,
                  defaultDesignation.element.stableElementId,
                );
              }}
            />
          ),
        },
        {
          title: "Appearance",
          component: (
            <AppearanceModifier
              onChange={(modifiers) => {
                onModifiersValueChange(
                  modifiers,
                  defaultDesignation.element.stableElementId,
                );
              }}
            />
          ),
        },
        {
          title: "Shadow",
          component: (
            <ShadowModifierComponent
              onChange={(modifiers) => {
                onModifiersValueChange(
                  modifiers,
                  defaultDesignation.element.stableElementId,
                );
              }}
            />
          ),
        },
      ],
    },
  ];

  return (
    <ModifierLayout
      sections={sections}
      onModifiersValueChange={onModifiersValueChange}
    />
  );
};

export default ButtonModifierBlock;
